import styled from 'styled-components'
import { colors } from 'shared/theme'
import InputArrowNewFooterSVG from 'shared/svg/input_arrow_new_footer.svg'

const InputArrowNewFooter = styled(InputArrowNewFooterSVG)`
  color: ${colors.white};
  height: 10px;
  width: 18px;
`

export default InputArrowNewFooter
